var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useUpdateEffect } from 'ahooks';
import { Toast } from './toast';
var toastArray = [];
export function show(p) {
  var props = typeof p === 'string' ? {
    content: p
  } : p;
  var timer = 0;
  var container = document.createElement('div');
  document.body.appendChild(container);
  var TempToast = function () {
    var _a = __read(useState(true), 2),
      visible = _a[0],
      setVisible = _a[1];
    var _b = __read(useState(__assign({
        duration: 3000
      }, props)), 2),
      state = _b[0],
      setState = _b[1];
    var _afterClose = function () {
      var unmountResult = ReactDOM.unmountComponentAtNode(container);
      if (unmountResult && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
    var destroy = useCallback(function () {
      setVisible(false);
    }, []);
    useEffect(function () {
      _clear();
      toastArray.push(_afterClose);
    }, []);
    useEffect(function () {
      if (state.duration !== 0 && 'duration' in state) {
        timer = window.setTimeout(destroy, state.duration);
      }
      return function () {
        if (timer !== 0) {
          window.clearTimeout(timer);
        }
      };
    }, []);
    useUpdateEffect(function () {
      if ('duration' in state) {
        window.clearTimeout(timer);
        timer = window.setTimeout(destroy, state.duration);
      }
    }, [state.duration]);
    return /*#__PURE__*/React.createElement(Toast, __assign({}, state, {
      visible: visible
    }));
  };
  ReactDOM.render( /*#__PURE__*/React.createElement(TempToast, null), container);
}
function _clear() {
  var fn = toastArray.pop();
  while (fn) {
    fn();
    fn = toastArray.pop();
  }
}
export function clear() {
  setTimeout(_clear);
}